<div class="categories" style="text-align: center">
    <h1 class="categoryHeader">קטגוריות</h1>
    <!--        <app-category-carousel  [categories]="categoriesToDisplay"></app-category-carousel>-->
    <div class="productBox" *ngFor="let prd of categoriesToDisplay" [ngStyle]="selectedCategory == (prd.name | clearWhiteSpace)?{background:'black', 'text-align':'center'}:{}" >

        <a *ngIf="selectedCategory == (prd.name| clearWhiteSpace)" [routerLink]="'..'" class="title text-truncate ">
            <img  [src]="'../../../assets/images/back.png'"  [attr.data-src]="'../../../assets/images/back.png'" class="swiper-lazy "/>
            <span class="titleCategory">
                <div class="dividerLine"></div>
                   לדף הקודם
            </span>
        </a>
        <a class="catelink" *ngIf="selectedCategory!= (prd.name| clearWhiteSpace) " [routerLink]="['/categories', prd.name | clearWhiteSpace]" class="title text-truncate ">
            <img  [src]="prd.image?prd.image:'https://romelux-light.com:8000/media/LOGO.png'" [attr.data-src]="prd.image?prd.image:'https://romelux-light.com:8000/media/LOGO.png'" class="swiper-lazy imageBox"/>
            <span class="titleCategory">
                <div class="dividerLine"></div>
                {{prd.name}}
            </span>
        </a>
    </div>
</div>
